import React from 'react';
import PropTypes from 'prop-types';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import FontIcon from 'material-ui/FontIcon';
import CircularProgress from 'material-ui/CircularProgress';

import { Icon } from '../components';
import Row from '../components/GridRow';
import EmptyTable from '../components/GridEmpty';

const styles = {
    loading: {
        position: 'absolute',
        zIndex: 1,
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        left: 0,
        right: 0,
    },
};

const getRowValue = (item, column, index) => {
    switch (typeof column.name) {
        case 'string':
            return item[column.name];

        case 'function':
            return column.name(item, index);

        default:
            throw new Error('Parâmetro name inválido.');
    }
};

class Grid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            columnsSearch: props.columns.filter(column => column.allowSearch),
            loading: false,
            pageIndex: 1,
            indexSorted: props.columnSortDefault > -1 ? props.columnSortDefault : 0,
            sortAscDirection: !!props.sortAscDirection,
            searchIndex: -1,
            searchText: '',
        };
    }

    async onChangePageIndex(index) {
        if (index < 1) {
            return;
        }
        this.setStateCustom({ pageIndex: index });
    }

    onSearch() {
        const {
            searchIndex,
            searchText,
            columnsSearch,
        } = this.state;
        const {
            dataSource,
        } = this.props;

        if (searchIndex < 0) {
            return dataSource;
        }
        const columnSearch = columnsSearch[searchIndex];
        const data = dataSource.filter((x, index) => {
            const value = getRowValue(x, columnSearch, index);
            return (value || '').toString().toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        });
        return data;
    }

    onSort(data) {
        const {
            indexSorted,
            sortAscDirection,
        } = this.state;
        const column = this.props.columns[indexSorted];
        const sortNumber = sortAscDirection ? 1 : -1;
        data.sort((x, y) => {
            const xValue = getRowValue(x, column);
            const yValue = getRowValue(y, column);
            if (xValue < yValue) {
                return -sortNumber;
            } else if (xValue > yValue) {
                return sortNumber;
            }
            return 0;
        });
        return data;
    }

    async setSort(index) {
        const {
            indexSorted,
            sortAscDirection,
        } = this.state;

        if (index !== indexSorted) {
            this.setStateCustom({ indexSorted: index, sortAscDirection: true });
        } else if (!sortAscDirection) {
            this.setStateCustom({ indexSorted: this.props.columnSortDefault, sortAscDirection: true });
        } else {
            this.setStateCustom({ indexSorted: index, sortAscDirection: false });
        }
    }

    setStateCustom(data) {
        if (this.gridRef) {
            this.setState(data);
        }
    }

    render() {
        const {
            rowsPerPage,
            columns,
            textTableEmpty,
            showSearch,
            onStyleRow,
        } = this.props;
        const {
            columnsSearch,
            loading,
            pageIndex,
            indexSorted,
            sortAscDirection,
            searchIndex,
            searchText,
        } = this.state;

        let data = this.onSearch();
        data = this.onSort(data);

        const count = data.length;
        const isEmpty = data.length <= 0 && !loading;
        const startIndex = isEmpty ? 0 : ((pageIndex - 1) * rowsPerPage);
        let endIndex = isEmpty ? 0 : (pageIndex * rowsPerPage);
        if (endIndex > count) {
            endIndex = count;
        }

        return (
            <div ref={(ref) => { this.gridRef = ref; }}>
                {
                    showSearch &&
                    <div style={{ textAlign: 'right', marginBottom: 8 }}>
                        <div>
                            <SelectField
                                onChange={(_, value) => this.setStateCustom({ searchIndex: value - 1 })}
                                value={searchIndex}
                            >
                                <MenuItem value={-1} primaryText="Sem filtro" />
                                {
                                    columnsSearch.map((column, index) =>
                                        // eslint-disable-next-line react/no-array-index-key
                                        <MenuItem key={index} value={index} primaryText={column.text} />)
                                }
                            </SelectField>
                        </div>
                        <div>
                            <TextField
                                disabled={searchIndex === -1}
                                hintText="Texto de busca"
                                value={searchText}
                                onChange={event => this.setStateCustom({ searchText: event.target.value })}
                                style={{ marginRight: 8, marginLeft: 8 }}
                            />
                        </div>
                    </div>
                }
                {
                    loading &&
                    <div style={styles.loading}>
                        <CircularProgress />
                    </div>
                }
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            {
                                columns.map((column, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <TableHeaderColumn key={index} style={{ width: column.width ? column.width : 'auto' }}>
                                        <div style={{ display: 'table', width: '100%' }}>
                                            <span style={{ verticalAlign: 'middle', display: 'table-cell' }}>{column.text}</span>
                                            {
                                                column.allowSort &&
                                                <IconButton style={{ float: 'right' }} onClick={() => this.setSort(index)}>
                                                    <Icon
                                                        color={indexSorted !== index ? 'rgba(0, 0, 0, 0.3)' : undefined}
                                                        name={indexSorted !== index || (indexSorted === index && sortAscDirection) ? 'arrow_downward' : 'arrow_upward'}
                                                    />
                                                </IconButton>
                                            }
                                        </div>
                                    </TableHeaderColumn>
                                ))
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false} showRowHover>
                        {
                            isEmpty ?
                                <EmptyTable textTableEmpty={textTableEmpty} columnsLength={columns.length} /> :
                                data.slice(startIndex, endIndex).map((item, index) =>
                                    // eslint-disable-next-line react/no-array-index-key
                                    <Row onStyleRow={onStyleRow} key={index} index={index} item={item} columns={columns} />)
                        }
                    </TableBody>
                </Table>
                <div style={{ textAlign: 'right', marginTop: 8 }}>
                    <span style={{ marginRight: 16 }}>{count === 0 ? 0 : startIndex + 1}-{endIndex} de {count}</span>
                    <FlatButton
                        // label="Anterior"
                        icon={<FontIcon className="material-icons">keyboard_arrow_left</FontIcon>}
                        onClick={() => this.onChangePageIndex(pageIndex - 1)}
                        disabled={loading || pageIndex < 2}
                    />
                    <FlatButton
                        // label="Próximo"
                        labelPosition="before"
                        icon={<FontIcon className="material-icons">keyboard_arrow_right</FontIcon>}
                        onClick={() => this.onChangePageIndex(pageIndex + 1)}
                        disabled={loading || (pageIndex * rowsPerPage) >= count}
                    />
                </div>
            </div>
        );
    }
}

Grid.defaultProps = {
    sortAscDirection: true,
    showSearch: true,
    columnSortDefault: 0,
    textTableEmpty: 'Sem registros.',
    rowsPerPage: 10,
    onStyleRow: undefined,
};

Grid.propTypes = {
    showSearch: PropTypes.bool,
    columnSortDefault: PropTypes.number,
    dataSource: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    textTableEmpty: PropTypes.string,
    rowsPerPage: PropTypes.number,
    sortAscDirection: PropTypes.bool,
    onStyleRow: PropTypes.func,
};

export default Grid;
